import type { EnrichedSwarovskiProductFrontendProductAggregatedReviews } from "@swo/storefront";

export function computeReviewsSlice(reviews: EnrichedSwarovskiProductFrontendProductAggregatedReviews) {
  if (reviews === null) {
    return {};
  }

  return {
    review: reviews.reviews.map(review => ({
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: review.rating.toFixed(1),
      },
      author: {
        "@type": "Person",
        name: review.author.name,
      },
    })),
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: reviews.averageRating.toFixed(1),
      bestRating: "5.0",
      ratingCount: reviews.reviews.length,
    },
  };
}
